export default __webpack_public_path__ + "static/media/demo-user.768f70be.svg";